import { useEffect } from "react";
import Preloader from "../../../app-components/preloader/Preloader";
import { Logo, VesselImage } from "../../../assets/img";
import useLoginTepngUser from "../../../api-services/api-query/authentication/UseLoginTepngUser";
import { LuClipboardCheck, LuShieldCheck, LuShip } from "react-icons/lu";

const query = new URLSearchParams(window.location.search);
const LoginTepngUser = () => {
  const { login, loading, error } = useLoginTepngUser();

  useEffect(() => {
    if (query.get("azureauthredirect") === "1") login();
  }, [login]);

  return (
    <main>
      <section className="flex h-[100vh]">
        <div
          className="hidden lg:flex w-2/3 bg-gray-800 flex items-center justify-center bg-cover bg-[50%_100%]"
          style={{ backgroundImage: `url(${VesselImage})` }}
        ></div>

        <div className="w-full lg:w-1/3 bg-white flex flex-col text-center">
          <div className="px-6  2xl:p-24">
            <div className="justify-center flex w-full mt-12">
              <img
                alt="company logo"
                src={Logo}
                className="w-[70px] flex-col"
              />
            </div>

            <h2 className="mt-16 flex-col font-semibold text-slate-800 text-[16px]">
              Welcome to Marine Vessel Inspection Portal
            </h2>

            <p className="text-xs px-3">
              Your gateway for ensuring safety and compliance in marine
              operations.
            </p>

            <div className="mt-12 flex gap-12 px-5 justify-center font-medium text-slate-500">
              <div className="w-full flex flex-col items-center justify-center text-center">
                <span className="bg-gray-100 rounded-3xl border-blue-900 border-2 px-[10px] py-[1px] text-blue-900 mb-1 font-bold">
                  1
                </span>
                <LuShip className="text-[3rem] text-blue-900" />
                <p className="text-xs px-1">Inspect Vessel</p>
              </div>

              <div className="w-full flex flex-col items-center justify-center text-center">
                <span className="bg-gray-100 rounded-3xl border-red-600 border-2 px-[8px] py-[1px] text-red-600 mb-1 font-bold">
                  2
                </span>
                <LuClipboardCheck className="text-[3rem] text-red-600" />
                <p className="text-xs px-1">Safety Checks</p>
              </div>

              <div className="w-full flex flex-col items-center justify-center text-center">
                <span className="bg-gray-100 rounded-3xl border-green-700 border-2 px-[8px] py-[1px] text-green-700 mb-1 font-bold">
                  3
                </span>
                <LuShieldCheck className="text-[3rem] text-green-700" />
                <p className="text-xs px-1">Take Full Action</p>
              </div>
            </div>

            {error && (
              <p className="text-red-600 text-xs mt-2">Error: {error}</p>
            )}

            <div>
              <button
                onClick={login}
                disabled={loading}
                className="disabled:bg-gray-200 disabled:text-gray-600 mt-12 bg-red-600 text-white font-normal px-20 py-2 rounded-3xl shadow-lg text-sm"
              >
                Sign In
              </button>
            </div>
          </div>

          <div className="overflow-hidden fixed bottom-0 mt-6 flex-col waveAnimation lg:w-1/3">
            <svg viewBox="0 0 700 150" preserveAspectRatio="none">
              <path
                className="w1 waveTop"
                d="M-8.74,71.55 C289.78,255.11 349.60,4.47 505.36,34.05 L500.00,150.00 L0.00,150.00 Z"
              />
              <path
                className="w2 waveMiddle"
                d="M-23.42,125.83 C187.63,45.89 299.38,57.73 526.80,123.86 L500.00,150.00 L0.00,150.00 Z"
              />
              <path
                className="w3 waveBottom"
                d="M-23.42,125.83 C172.96,-152.44 217.55,183.06 504.22,55.77 L500.00,150.00 L0.00,150.00 Z"
              />
            </svg>
          </div>
        </div>
      </section>

      <Preloader loading={loading} />
    </main>
  );
};

export default LoginTepngUser;


// comment